export default "__VITE_ASSET__BgXtOS3R__"